import { Box, Typography } from '@mui/material';
import { format, formatDistanceToNow, parseISO } from 'date-fns';

const TimestampDisplay = ({
  date,
  prefix = '',
  withDistanceToNow = false,
}: {
  date: Date | string | null | undefined;
  prefix?: string;
  withDistanceToNow?: boolean;
}) => {
  const newDate = typeof date === 'string' ? parseISO(date) : date;

  if (!newDate) {
    return null;
  }

  return (
    <Box sx={{ gap: 1 }}>
      <Typography component="span" variant="body2">
        {prefix}
        {format(newDate, 'P')},
      </Typography>
      <Typography
        component="span"
        sx={{ color: 'inherit', pl: 0.5, fontStyle: 'italic' }}
        variant="caption"
      >
        {format(newDate, 'pp').toLowerCase()}
      </Typography>
      {withDistanceToNow && (
        <Typography
          component="span"
          sx={{ color: 'inherit', pl: 0.5 }}
          variant="caption"
        >
          ({formatDistanceToNow(newDate, { addSuffix: true })})
        </Typography>
      )}
    </Box>
  );
};

export default TimestampDisplay;
